export default "__VITE_ASSET__8XsoGjWy__"